import { IntegrationTermsAndConditions, IntergrationInstructionStep, StrVal } from '../api/types';

export function IsIntegrationValid(
  values: StrVal,
  steps: IntergrationInstructionStep[],
  termsAndConditions: IntegrationTermsAndConditions,
): boolean {
  var output = true;

  steps.forEach((step) => {
    step.inputs?.forEach((input) => {
      var val = values[input.propertyName] || '';
      if (input.validationRules.required && !val) {
        output = false;
      }
      if (input.validationRules.pattern && val && !new RegExp(input.validationRules.pattern).test(val)) {
        output = false;
      }
    });
  });

  if (termsAndConditions) {
    let input = termsAndConditions.input;
    let val = values[input.propertyName] || '';
    if (input.validationRules.required && !val) {
      output = false;
    }
    if (input.validationRules.pattern && val && !new RegExp(input.validationRules.pattern).test(val)) {
      output = false;
    }
  }

  return output;
}

export function ValidationErrorMessages(validationErrors: { [name: string]: string }, errorCode: string): string[] {
  var msg: string[] = [];
  switch (errorCode) {
    case '1000':
      msg.push('We are unable to find your account.');
      break;

    case '1001':
      msg.push('This account already exists.');
      break;

    case '1002':
      msg.push('The integration version you are using is not supported.');
      break;

    case '1003':
      msg.push('We can not verify the credentials you have entered.');
      break;

    default: {
      try {
        for (var m in validationErrors) {
          msg.push((validationErrors[m] as any)[0].message);
        }
      } catch {}
    }
  }

  return msg.length > 0 ? msg : ['Unable to link account, please try again.'];
}
